__turbopack_context__.v({
  "dragging": "En1i8G_dragging",
  "root": "En1i8G_root",
});
